import { render, staticRenderFns } from "./SugerenciasNotEnded.vue?vue&type=template&id=1b511e26&"
import script from "./SugerenciasNotEnded.vue?vue&type=script&lang=js&"
export * from "./SugerenciasNotEnded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports